import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { getCoachCertifications } from '../../../actions/coachCertificationActions'
import CertificationNotice from './CertificationNotice'
import CertificationLoader from './CertificationLoader'
import CertificationCard from './CertificationCard'

import classes from './CertificationsPage.module.scss'

const CertificationsPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { certifications, listStatus } = useSelector(state => state.coachCertification)

  useEffect(() => { dispatch(getCoachCertifications()) }, [dispatch])

  if (listStatus === 'failed') { return <CertificationNotice notFound={false} /> }
  if (listStatus !== 'loaded') { return <CertificationLoader /> }
  if (certifications.length === 0) { return <CertificationNotice notFound /> }

  return (
    <main className={classes.page}>
      <span className={classes.eyebrow}>{t('portal.certification.list.eyebrow')}</span>
      <h1 className={classes.title}>{t('portal.certification.list.title')}</h1>
      <div className={classes.grid}>
        {certifications.map(certification => <CertificationCard key={certification.id} certification={certification} />)}
      </div>
    </main>
  )
}

export default CertificationsPage
